// =========================
// GBOpening 用スタイル群
// =========================

// オープニング全体の外側 Box
export const OPENING_CONTAINER_BOX_SX = {
    m: 1,
    p: 4,
};

// 画面部分の Paper
export const OPENING_SCREEN_PAPER_SX = {
    m: 1,
    p: 1,
    bgcolor: '#f5f5dc',
    borderRadius: '1px',
    height: '250px',
    width: '250px',
    position: 'absolute',
    top: '20px',
    left: '40px',
};

// タイトル：ポケットモンスター
export const OPENING_TITLE_MAIN_SX = {
    fontFamily: 'DotGothic16',
    fontSize: '27px',
    color: '#000000',
};

// タイトル：POKET MONSTERS
export const OPENING_TITLE_SUB_SX = {
    fontFamily: 'DotGothic16',
    fontSize: '20px',
    color: '#000000',
};

// タイトル：Red Version
export const OPENING_TITLE_VERSION_SX = {
    fontFamily: 'DotGothic16',
    fontSize: '15px',
    color: '#000000',
};

// Start ボタンをおしてね（点滅テキスト）
export const OPENING_START_TEXT_SX = {
    fontFamily: 'DotGothic16',
    fontSize: '15px',
    color: '#000000',
};

// レッドの画像
export const OPENING_RED_IMG_STYLE = {
    width: '60%',
    height: 'auto',
};

// ヒトカゲの画像
export const OPENING_HITOKAGE_IMG_STYLE = {
    width: '60%',
    height: 'auto',
    transform: 'translateY(40px)',
};

// コピーライト表記
export const OPENING_COPYRIGHT_TEXT_SX = {
    fontFamily: 'DotGothic16',
    fontSize: '12px',
    color: '#000000',
};
